import { render, staticRenderFns } from "./ColDepAdminUserList.vue?vue&type=template&id=1f27a4e6"
import script from "./ColDepAdminUserList.vue?vue&type=script&lang=js"
export * from "./ColDepAdminUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports